import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { WidgetFindDto } from '@zaoblako/shared/modules/dashboard/dtos/widget/widget.find.dto';
import { TrafficWidgetFindDto } from '@zaoblako/shared/modules/report/dtos/traffic/traffic.widget.find.dto';
import { TrafficWidgetReportQueryDto } from '@zaoblako/shared/modules/report/dtos/traffic/traffic.widget.report.query.dto';
import { PeriodEnum } from '@zaoblako/shared/modules/report/enums/period.enum';
import { DashboardService } from '@zaoblako/web/core/services/dashboard/dashboard.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'crm-widget-traffic',
  templateUrl: './widget-traffic.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetTrafficComponent implements OnInit {
  @Input() public widgetData: WidgetFindDto;

  public queryParams: TrafficWidgetReportQueryDto = {
    from: moment().startOf('month').format('YYYY-MM-DD') as unknown as Date,
    to: moment().endOf('month').format('YYYY-MM-DD') as unknown as Date
  };

  public loading = false;
  public result: TrafficWidgetFindDto;

  public constructor(private readonly dashboardService: DashboardService, private readonly cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.load();
  }

  public load() {
    this.loading = true;
    this.cdRef.markForCheck();

    if (this.widgetData.filter.period === PeriodEnum.DAY) {
      this.queryParams.from = moment().startOf('day').format('YYYY-MM-DD') as unknown as Date;
      this.queryParams.to = moment().endOf('day').format('YYYY-MM-DD') as unknown as Date;
    } else if (this.widgetData.filter.period === PeriodEnum.WEEK) {
      this.queryParams.from = moment().startOf('week').format('YYYY-MM-DD') as unknown as Date;
      this.queryParams.to = moment().endOf('week').format('YYYY-MM-DD') as unknown as Date;
    } else if (this.widgetData.filter.period === PeriodEnum.MONTH) {
      this.queryParams.from = moment().startOf('month').format('YYYY-MM-DD') as unknown as Date;
      this.queryParams.to = moment().endOf('month').format('YYYY-MM-DD') as unknown as Date;
    }

    this.dashboardService.trafficWidget(this.queryParams).subscribe({
      next: (result) => {
        this.result = result;
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
